import React from 'react';

interface StatusBadgeProps {
  status: string;
  label?: string;
  size?: 'sm' | 'md';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label, size = 'sm' }) => {
  const normalized = status.toLowerCase().replace(/_/g, ' ');
  const displayLabel = label || normalized.charAt(0).toUpperCase() + normalized.slice(1);

  const getStyle = () => {
    switch (status.toLowerCase()) {
      case 'settled':
      case 'verified':
      case 'active':
      case 'approved':
      case 'published':
      case 'successful':
      case 'tier3_champion':
        return 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30 dark:bg-emerald-500/15 dark:text-emerald-300 light:bg-emerald-100 light:text-emerald-700 light:border-emerald-200';
      
      case 'held':
      case 'pending':
      case 'under_review':
      case 'draft':
      case 'in_progress':
      case 'tier2_silver':
        return 'bg-amber-500/15 text-amber-400 border-amber-500/30 dark:bg-amber-500/15 dark:text-amber-300 light:bg-amber-100 light:text-amber-700 light:border-amber-200';
      
      case 'dispatched':
      case 'scheduled':
      case 'open':
      case 'tier1_bronze':
        return 'bg-cyan-500/15 text-cyan-400 border-cyan-500/30 dark:bg-cyan-500/15 dark:text-cyan-300 light:bg-cyan-100 light:text-cyan-700 light:border-cyan-200';
      
      case 'delivered':
        return 'bg-blue-500/15 text-blue-400 border-blue-500/30 dark:bg-blue-500/15 dark:text-blue-300 light:bg-blue-100 light:text-blue-700 light:border-blue-200';

      case 'disputed':
      case 'dispute':
      case 'flagged':
      case 'urgent':
      case 'high':
        return 'bg-purple-500/15 text-purple-400 border-purple-500/30 dark:bg-purple-500/15 dark:text-purple-300 light:bg-purple-100 light:text-purple-700 light:border-purple-200';

      case 'refunded':
      case 'banned':
      case 'rejected':
      case 'delisted':
      case 'cancelled':
      case 'failed':
      case 'closed':
        return 'bg-rose-500/15 text-rose-400 border-rose-500/30 dark:bg-rose-500/15 dark:text-rose-300 light:bg-rose-100 light:text-rose-700 light:border-rose-200';

      case 'suspended':
        return 'bg-orange-500/15 text-orange-400 border-orange-500/30 dark:bg-orange-500/15 dark:text-orange-300 light:bg-orange-100 light:text-orange-700 light:border-orange-200';

      default:
        return 'bg-gray-500/15 text-gray-400 border-gray-500/30 dark:bg-gray-500/15 dark:text-gray-300 light:bg-gray-100 light:text-gray-700 light:border-gray-200';
    }
  };

  const sizeClass = size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center rounded-full font-medium border ${sizeClass} ${getStyle()}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5 opacity-75"></span>
      {displayLabel}
    </span>
  );
};
